import type { ProjectState } from "hooks/useProjects/useProjects.types";
import { isRunAiCreditsUnlimited } from "utils/aiCreditsAvailability";

/**
 * Remaining AI credits as the header's Run AI button shows them ("1,240"),
 * or undefined when the balance is unknown or the Run AI dialog would call
 * it unlimited (same rule, `isRunAiCreditsUnlimited`).
 */
export const formatCredits = (project: Pick<ProjectState, "aiCredits">): string | undefined => {
  const credits = project.aiCredits;
  if (!credits || isRunAiCreditsUnlimited(credits)) return undefined;
  return Math.max(0, Math.floor(credits.remaining)).toLocaleString("en-US");
};

/** "42 credits", "1 credit", or undefined when the count is hidden. */
export const formatCreditsLabel = (
  project: Pick<ProjectState, "aiCredits">
): string | undefined => {
  const count = formatCredits(project);
  if (count === undefined) return undefined;
  return `${count} ${count === "1" ? "credit" : "credits"}`;
};
